export default "/etc.clientlibs/des/user-auth/clientlibs/des-user-auth/resources/45598049ac0ef272ca9fda0e799df4f5.png";